export const MOVEMENT_TYPE = {
  SHOPPING: 'SHOPPING',
  CASHBACK: 'CASHBACK',
  BONUS: 'BONUS',
  EXPIRATION_POINTS: 'EXPIRATION_POINTS',
  REDEEM_POINTS: 'REDEEM_POINTS',
  REDEEM_FACTORY_VISIT: 'REDEEM_FACTORY_VISIT',
  REDEEM_EXCLUSIVE_EVENT: 'REDEEM_EXCLUSIVE_EVENT',
  REVERSAL_POINTS: 'REVERSAL_POINTS',
  MANUAL_ADJUSTMENT: 'MANUAL_ADJUSTMENT',
  CONTRACT_CANCELLATION: 'CONTRACT_CANCELLATION',
  PURCHASE_CANCELLED: 'PURCHASE_CANCELLED',
  BIRTHDAY_CAMPAIGN: 'BIRTHDAY_CAMPAIGN',
  MISSION_ACCOMPLISHED: 'MISSION_ACCOMPLISHED',
  BENEFIT_USE: 'BENEFIT_USE',
  ACCELERATOR: 'ACCELERATOR',
  OPTOUT: 'OPTOUT'
} as const
